import moment from 'moment';
import { humanise } from 'components/atoms/humanised-date';
import { ProjectPhaseEvent } from '../../event-types';

export const projectPhaseTemplate = ({
  id,
  phaseName,
  activePhase,
}: Pick<ProjectPhaseEvent, 'id' | 'phaseName' | 'activePhase'>): string =>
  `<div class="content" data-event-id=${id}>${
    activePhase ? phaseName : ''
  }</div>`;

export const projectPhaseTooltip = ({
  phaseName,
  startDate,
  endDate,
}: Pick<ProjectPhaseEvent, 'phaseName' | 'startDate' | 'endDate'>): string =>
  `<div><span>Phase name:</span><strong> ${phaseName}</strong></div><div><span>Dates:</span><strong> ${humanise(
    moment(startDate),
  )} - ${humanise(moment(endDate))}</strong></div>`;
